module.exports = __webpack_public_path__ + "img/laser-turret-gun-start.4070ce38.png";